import React from 'react';
import './index.css';

export type IndicatorStateOptions =
  | 'loading'
  | 'complete'
  | 'error'
  | 'new'
  | 'warning';

type IndicatorMaping = {
  [key in IndicatorStateOptions]: {
    buttonClass: string;
    spanClass: string;
    display: string;
  };
};

const mapping: IndicatorMaping = {
  complete: {
    buttonClass: 'btn btn-success indicator',
    spanClass: 'oi oi-check',
    display: 'Complete',
  },
  new: {
    buttonClass: 'btn btn-light indicator',
    spanClass: 'oi oi-plus',
    display: 'New',
  },
  loading: {
    buttonClass: 'btn btn-primary indicator',
    spanClass: 'spinner-border spinner-border-sm',
    display: 'Loading...',
  },
  warning: {
    buttonClass: 'btn btn-warning indicator',
    spanClass: 'oi oi-warning',
    display: 'Error',
  },
  error: {
    buttonClass: 'btn btn-danger indicator',
    spanClass: 'oi oi-x',
    display: 'Error',
  },
};

type IndicatorProps = {
  state?: IndicatorStateOptions;
  spanClassName?: string;
  buttonClassName?: string;
};

const Indicator: React.FC<IndicatorProps> = ({
  state = 'new',
  spanClassName,
  buttonClassName,
}) => {
  const { spanClass, display, buttonClass } = mapping[state];
  return (
    <button
      className={`${buttonClass} ${buttonClassName ? buttonClassName : ''}`}
      type="button"
      disabled>
      <span
        className={`ic-animated ${spanClass} ${
          spanClassName ? spanClassName : ''
        } `}
        role="status"
        aria-hidden="true"
      />
      <span className="sr-only">{display}</span>
    </button>
  );
};

export default Indicator;
